"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEventListener = exports.addEventListener = exports.getDeviceId = exports.setPushToken = exports.ping = exports.createUserDeleteRequest = exports.createUserWithPet = exports.deleteMyAccount = exports.getUser = exports.logoutUser = exports.updateCurrentUserPassword = exports.editCurrentUser = exports.userLogin = exports.getCurrentUser = exports.resetPassword = exports.validateToken = exports.sendRequestResetPassword = exports.countMyPets = exports.editMyPet = exports.createMyPet = exports.getMyPetById = exports.getAllMyPets = exports.getHomeData = exports.getAllPosts = exports.getPostById = exports.getHistoryByPet = exports.getAllHospitalizationForUserByPet = exports.getHospitalizationById = exports.getAllMyHospitalizations = exports.createContact = exports.getAllMyConsultations = exports.editShowInSiteClinicAdminUser = exports.createClinicAdminUserToShowInSite = exports.getAllClinicAdminUsers = exports.editCurrentClinicAdminUser = exports.editClinicAdminUser = exports.createClinicAdminUser = exports.logoutAdminUser = exports.adminLogin = exports.deleteAdminUser = exports.editAdminUser = exports.createAdminUser = exports.getAllAdminUsers = exports.getCurrentAdminLogged = exports.getAdminUser = exports.getAllVetsShowInSite = exports.getVetById = exports.getOneVeterinaryClinicById = exports.getAllVeterinaryClinicPaginated = exports.getOneShowInSiteClinicAdminUser = exports.getAllShowInSiteClinicAdminUsers = exports.uploadUncompressedUncertainImage = exports.uploadUncompressedImage = exports.uploadUncertainImage = exports.uploadImage = exports.uploadUncertainFile = exports.valueFromTranslationErrorType = exports.allDisplayableValuesErrorType = exports.allTranslatedValuesErrorType = exports.allValuesErrorType = exports.translateErrorType = exports.ErrorType = exports.valueFromTranslationFileFormat = exports.allDisplayableValuesFileFormat = exports.allTranslatedValuesFileFormat = exports.allValuesFileFormat = exports.translateFileFormat = exports.FileFormat = exports.valueFromTranslationImageFormat = exports.allDisplayableValuesImageFormat = exports.allTranslatedValuesImageFormat = exports.allValuesImageFormat = exports.translateImageFormat = exports.ImageFormat = exports.valueFromTranslationSpecies = exports.allDisplayableValuesSpecies = exports.allTranslatedValuesSpecies = exports.allValuesSpecies = exports.translateSpecies = exports.Species = exports.valueFromTranslationPetParents = exports.allDisplayableValuesPetParents = exports.allTranslatedValuesPetParents = exports.allValuesPetParents = exports.translatePetParents = exports.PetParents = exports.valueFromTranslationAnimalSex = exports.allDisplayableValuesAnimalSex = exports.allTranslatedValuesAnimalSex = exports.allValuesAnimalSex = exports.translateAnimalSex = exports.AnimalSex = exports.valueFromTranslationPaymentMethod = exports.allDisplayableValuesPaymentMethod = exports.allTranslatedValuesPaymentMethod = exports.allValuesPaymentMethod = exports.translatePaymentMethod = exports.PaymentMethod = exports.valueFromTranslationStateUF = exports.allDisplayableValuesStateUF = exports.allTranslatedValuesStateUF = exports.allValuesStateUF = exports.translateStateUF = exports.StateUF = exports.setStrings = exports.setUrl = exports.parseCookies = exports.isServer = void 0;
const ua_parser_js_1 = require("ua-parser-js");
const axios_1 = require("axios");
const Cookies = require("js-cookie");
const cookie = require("cookie");
let baseUrl = "localhost:8000";
let strings = null;
exports.isServer = typeof window === "undefined";
exports.parseCookies = (req) => {
    return cookie.parse(req ? req.headers.cookie || "" : document.cookie);
};
function setUrl(url) {
    baseUrl = url;
}
exports.setUrl = setUrl;
function setStrings(newStrings) {
    strings = newStrings;
}
exports.setStrings = setStrings;
var StateUF;
(function (StateUF) {
    StateUF["AC"] = "AC";
    StateUF["AL"] = "AL";
    StateUF["AP"] = "AP";
    StateUF["AM"] = "AM";
    StateUF["BA"] = "BA";
    StateUF["CE"] = "CE";
    StateUF["DF"] = "DF";
    StateUF["ES"] = "ES";
    StateUF["GO"] = "GO";
    StateUF["MA"] = "MA";
    StateUF["MT"] = "MT";
    StateUF["MS"] = "MS";
    StateUF["MG"] = "MG";
    StateUF["PA"] = "PA";
    StateUF["PB"] = "PB";
    StateUF["PR"] = "PR";
    StateUF["PE"] = "PE";
    StateUF["PI"] = "PI";
    StateUF["RJ"] = "RJ";
    StateUF["RN"] = "RN";
    StateUF["RS"] = "RS";
    StateUF["RO"] = "RO";
    StateUF["RR"] = "RR";
    StateUF["SC"] = "SC";
    StateUF["SP"] = "SP";
    StateUF["SE"] = "SE";
    StateUF["TO"] = "TO";
})(StateUF = exports.StateUF || (exports.StateUF = {}));
function translateStateUF(enumStateUF) {
    switch (enumStateUF) {
        case StateUF.AC: {
            return strings ? strings["enum"]["StateUF"]["AC"] || StateUF.AC : StateUF.AC;
        }
        case StateUF.AL: {
            return strings ? strings["enum"]["StateUF"]["AL"] || StateUF.AL : StateUF.AL;
        }
        case StateUF.AP: {
            return strings ? strings["enum"]["StateUF"]["AP"] || StateUF.AP : StateUF.AP;
        }
        case StateUF.AM: {
            return strings ? strings["enum"]["StateUF"]["AM"] || StateUF.AM : StateUF.AM;
        }
        case StateUF.BA: {
            return strings ? strings["enum"]["StateUF"]["BA"] || StateUF.BA : StateUF.BA;
        }
        case StateUF.CE: {
            return strings ? strings["enum"]["StateUF"]["CE"] || StateUF.CE : StateUF.CE;
        }
        case StateUF.DF: {
            return strings ? strings["enum"]["StateUF"]["DF"] || StateUF.DF : StateUF.DF;
        }
        case StateUF.ES: {
            return strings ? strings["enum"]["StateUF"]["ES"] || StateUF.ES : StateUF.ES;
        }
        case StateUF.GO: {
            return strings ? strings["enum"]["StateUF"]["GO"] || StateUF.GO : StateUF.GO;
        }
        case StateUF.MA: {
            return strings ? strings["enum"]["StateUF"]["MA"] || StateUF.MA : StateUF.MA;
        }
        case StateUF.MT: {
            return strings ? strings["enum"]["StateUF"]["MT"] || StateUF.MT : StateUF.MT;
        }
        case StateUF.MS: {
            return strings ? strings["enum"]["StateUF"]["MS"] || StateUF.MS : StateUF.MS;
        }
        case StateUF.MG: {
            return strings ? strings["enum"]["StateUF"]["MG"] || StateUF.MG : StateUF.MG;
        }
        case StateUF.PA: {
            return strings ? strings["enum"]["StateUF"]["PA"] || StateUF.PA : StateUF.PA;
        }
        case StateUF.PB: {
            return strings ? strings["enum"]["StateUF"]["PB"] || StateUF.PB : StateUF.PB;
        }
        case StateUF.PR: {
            return strings ? strings["enum"]["StateUF"]["PR"] || StateUF.PR : StateUF.PR;
        }
        case StateUF.PE: {
            return strings ? strings["enum"]["StateUF"]["PE"] || StateUF.PE : StateUF.PE;
        }
        case StateUF.PI: {
            return strings ? strings["enum"]["StateUF"]["PI"] || StateUF.PI : StateUF.PI;
        }
        case StateUF.RJ: {
            return strings ? strings["enum"]["StateUF"]["RJ"] || StateUF.RJ : StateUF.RJ;
        }
        case StateUF.RN: {
            return strings ? strings["enum"]["StateUF"]["RN"] || StateUF.RN : StateUF.RN;
        }
        case StateUF.RS: {
            return strings ? strings["enum"]["StateUF"]["RS"] || StateUF.RS : StateUF.RS;
        }
        case StateUF.RO: {
            return strings ? strings["enum"]["StateUF"]["RO"] || StateUF.RO : StateUF.RO;
        }
        case StateUF.RR: {
            return strings ? strings["enum"]["StateUF"]["RR"] || StateUF.RR : StateUF.RR;
        }
        case StateUF.SC: {
            return strings ? strings["enum"]["StateUF"]["SC"] || StateUF.SC : StateUF.SC;
        }
        case StateUF.SP: {
            return strings ? strings["enum"]["StateUF"]["SP"] || StateUF.SP : StateUF.SP;
        }
        case StateUF.SE: {
            return strings ? strings["enum"]["StateUF"]["SE"] || StateUF.SE : StateUF.SE;
        }
        case StateUF.TO: {
            return strings ? strings["enum"]["StateUF"]["TO"] || StateUF.TO : StateUF.TO;
        }
    }
    return "";
}
exports.translateStateUF = translateStateUF;
function allValuesStateUF() {
    return [
        StateUF.AC,
        StateUF.AL,
        StateUF.AP,
        StateUF.AM,
        StateUF.BA,
        StateUF.CE,
        StateUF.DF,
        StateUF.ES,
        StateUF.GO,
        StateUF.MA,
        StateUF.MT,
        StateUF.MS,
        StateUF.MG,
        StateUF.PA,
        StateUF.PB,
        StateUF.PR,
        StateUF.PE,
        StateUF.PI,
        StateUF.RJ,
        StateUF.RN,
        StateUF.RS,
        StateUF.RO,
        StateUF.RR,
        StateUF.SC,
        StateUF.SP,
        StateUF.SE,
        StateUF.TO,
    ];
}
exports.allValuesStateUF = allValuesStateUF;
function allTranslatedValuesStateUF() {
    return [
        translateStateUF(StateUF.AC),
        translateStateUF(StateUF.AL),
        translateStateUF(StateUF.AP),
        translateStateUF(StateUF.AM),
        translateStateUF(StateUF.BA),
        translateStateUF(StateUF.CE),
        translateStateUF(StateUF.DF),
        translateStateUF(StateUF.ES),
        translateStateUF(StateUF.GO),
        translateStateUF(StateUF.MA),
        translateStateUF(StateUF.MT),
        translateStateUF(StateUF.MS),
        translateStateUF(StateUF.MG),
        translateStateUF(StateUF.PA),
        translateStateUF(StateUF.PB),
        translateStateUF(StateUF.PR),
        translateStateUF(StateUF.PE),
        translateStateUF(StateUF.PI),
        translateStateUF(StateUF.RJ),
        translateStateUF(StateUF.RN),
        translateStateUF(StateUF.RS),
        translateStateUF(StateUF.RO),
        translateStateUF(StateUF.RR),
        translateStateUF(StateUF.SC),
        translateStateUF(StateUF.SP),
        translateStateUF(StateUF.SE),
        translateStateUF(StateUF.TO),
    ];
}
exports.allTranslatedValuesStateUF = allTranslatedValuesStateUF;
function allDisplayableValuesStateUF() {
    return allTranslatedValuesStateUF().sort();
}
exports.allDisplayableValuesStateUF = allDisplayableValuesStateUF;
function valueFromTranslationStateUF(translation) {
    const index = allTranslatedValuesStateUF().indexOf(translation);
    return allValuesStateUF()[index] || StateUF.AC;
}
exports.valueFromTranslationStateUF = valueFromTranslationStateUF;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["pix"] = "pix";
    PaymentMethod["cash"] = "cash";
    PaymentMethod["creditCard"] = "creditCard";
    PaymentMethod["debitCard"] = "debitCard";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
function translatePaymentMethod(enumPaymentMethod) {
    switch (enumPaymentMethod) {
        case PaymentMethod.pix: {
            return strings ? strings["enum"]["PaymentMethod"]["pix"] || PaymentMethod.pix : PaymentMethod.pix;
        }
        case PaymentMethod.cash: {
            return strings ? strings["enum"]["PaymentMethod"]["cash"] || PaymentMethod.cash : PaymentMethod.cash;
        }
        case PaymentMethod.creditCard: {
            return strings ? strings["enum"]["PaymentMethod"]["creditCard"] || PaymentMethod.creditCard : PaymentMethod.creditCard;
        }
        case PaymentMethod.debitCard: {
            return strings ? strings["enum"]["PaymentMethod"]["debitCard"] || PaymentMethod.debitCard : PaymentMethod.debitCard;
        }
    }
    return "";
}
exports.translatePaymentMethod = translatePaymentMethod;
function allValuesPaymentMethod() {
    return [
        PaymentMethod.pix,
        PaymentMethod.cash,
        PaymentMethod.creditCard,
        PaymentMethod.debitCard,
    ];
}
exports.allValuesPaymentMethod = allValuesPaymentMethod;
function allTranslatedValuesPaymentMethod() {
    return [
        translatePaymentMethod(PaymentMethod.pix),
        translatePaymentMethod(PaymentMethod.cash),
        translatePaymentMethod(PaymentMethod.creditCard),
        translatePaymentMethod(PaymentMethod.debitCard),
    ];
}
exports.allTranslatedValuesPaymentMethod = allTranslatedValuesPaymentMethod;
function allDisplayableValuesPaymentMethod() {
    return allTranslatedValuesPaymentMethod().sort();
}
exports.allDisplayableValuesPaymentMethod = allDisplayableValuesPaymentMethod;
function valueFromTranslationPaymentMethod(translation) {
    const index = allTranslatedValuesPaymentMethod().indexOf(translation);
    return allValuesPaymentMethod()[index] || PaymentMethod.pix;
}
exports.valueFromTranslationPaymentMethod = valueFromTranslationPaymentMethod;
var AnimalSex;
(function (AnimalSex) {
    AnimalSex["male"] = "male";
    AnimalSex["female"] = "female";
})(AnimalSex = exports.AnimalSex || (exports.AnimalSex = {}));
function translateAnimalSex(enumAnimalSex) {
    switch (enumAnimalSex) {
        case AnimalSex.male: {
            return strings ? strings["enum"]["AnimalSex"]["male"] || AnimalSex.male : AnimalSex.male;
        }
        case AnimalSex.female: {
            return strings ? strings["enum"]["AnimalSex"]["female"] || AnimalSex.female : AnimalSex.female;
        }
    }
    return "";
}
exports.translateAnimalSex = translateAnimalSex;
function allValuesAnimalSex() {
    return [
        AnimalSex.male,
        AnimalSex.female,
    ];
}
exports.allValuesAnimalSex = allValuesAnimalSex;
function allTranslatedValuesAnimalSex() {
    return [
        translateAnimalSex(AnimalSex.male),
        translateAnimalSex(AnimalSex.female),
    ];
}
exports.allTranslatedValuesAnimalSex = allTranslatedValuesAnimalSex;
function allDisplayableValuesAnimalSex() {
    return allTranslatedValuesAnimalSex().sort();
}
exports.allDisplayableValuesAnimalSex = allDisplayableValuesAnimalSex;
function valueFromTranslationAnimalSex(translation) {
    const index = allTranslatedValuesAnimalSex().indexOf(translation);
    return allValuesAnimalSex()[index] || AnimalSex.male;
}
exports.valueFromTranslationAnimalSex = valueFromTranslationAnimalSex;
var PetParents;
(function (PetParents) {
    PetParents["father"] = "father";
    PetParents["mother"] = "mother";
})(PetParents = exports.PetParents || (exports.PetParents = {}));
function translatePetParents(enumPetParents) {
    switch (enumPetParents) {
        case PetParents.father: {
            return strings ? strings["enum"]["PetParents"]["father"] || PetParents.father : PetParents.father;
        }
        case PetParents.mother: {
            return strings ? strings["enum"]["PetParents"]["mother"] || PetParents.mother : PetParents.mother;
        }
    }
    return "";
}
exports.translatePetParents = translatePetParents;
function allValuesPetParents() {
    return [
        PetParents.father,
        PetParents.mother,
    ];
}
exports.allValuesPetParents = allValuesPetParents;
function allTranslatedValuesPetParents() {
    return [
        translatePetParents(PetParents.father),
        translatePetParents(PetParents.mother),
    ];
}
exports.allTranslatedValuesPetParents = allTranslatedValuesPetParents;
function allDisplayableValuesPetParents() {
    return allTranslatedValuesPetParents().sort();
}
exports.allDisplayableValuesPetParents = allDisplayableValuesPetParents;
function valueFromTranslationPetParents(translation) {
    const index = allTranslatedValuesPetParents().indexOf(translation);
    return allValuesPetParents()[index] || PetParents.father;
}
exports.valueFromTranslationPetParents = valueFromTranslationPetParents;
var Species;
(function (Species) {
    Species["dog"] = "dog";
    Species["cat"] = "cat";
    Species["rodents"] = "rodents";
    Species["reptiles"] = "reptiles";
    Species["fish"] = "fish";
})(Species = exports.Species || (exports.Species = {}));
function translateSpecies(enumSpecies) {
    switch (enumSpecies) {
        case Species.dog: {
            return strings ? strings["enum"]["Species"]["dog"] || Species.dog : Species.dog;
        }
        case Species.cat: {
            return strings ? strings["enum"]["Species"]["cat"] || Species.cat : Species.cat;
        }
        case Species.rodents: {
            return strings ? strings["enum"]["Species"]["rodents"] || Species.rodents : Species.rodents;
        }
        case Species.reptiles: {
            return strings ? strings["enum"]["Species"]["reptiles"] || Species.reptiles : Species.reptiles;
        }
        case Species.fish: {
            return strings ? strings["enum"]["Species"]["fish"] || Species.fish : Species.fish;
        }
    }
    return "";
}
exports.translateSpecies = translateSpecies;
function allValuesSpecies() {
    return [
        Species.dog,
        Species.cat,
        Species.rodents,
        Species.reptiles,
        Species.fish,
    ];
}
exports.allValuesSpecies = allValuesSpecies;
function allTranslatedValuesSpecies() {
    return [
        translateSpecies(Species.dog),
        translateSpecies(Species.cat),
        translateSpecies(Species.rodents),
        translateSpecies(Species.reptiles),
        translateSpecies(Species.fish),
    ];
}
exports.allTranslatedValuesSpecies = allTranslatedValuesSpecies;
function allDisplayableValuesSpecies() {
    return allTranslatedValuesSpecies().sort();
}
exports.allDisplayableValuesSpecies = allDisplayableValuesSpecies;
function valueFromTranslationSpecies(translation) {
    const index = allTranslatedValuesSpecies().indexOf(translation);
    return allValuesSpecies()[index] || Species.dog;
}
exports.valueFromTranslationSpecies = valueFromTranslationSpecies;
var ImageFormat;
(function (ImageFormat) {
    ImageFormat["png"] = "png";
    ImageFormat["jpeg"] = "jpeg";
})(ImageFormat = exports.ImageFormat || (exports.ImageFormat = {}));
function translateImageFormat(enumImageFormat) {
    switch (enumImageFormat) {
        case ImageFormat.png: {
            return strings ? strings["enum"]["ImageFormat"]["png"] || ImageFormat.png : ImageFormat.png;
        }
        case ImageFormat.jpeg: {
            return strings ? strings["enum"]["ImageFormat"]["jpeg"] || ImageFormat.jpeg : ImageFormat.jpeg;
        }
    }
    return "";
}
exports.translateImageFormat = translateImageFormat;
function allValuesImageFormat() {
    return [
        ImageFormat.png,
        ImageFormat.jpeg,
    ];
}
exports.allValuesImageFormat = allValuesImageFormat;
function allTranslatedValuesImageFormat() {
    return [
        translateImageFormat(ImageFormat.png),
        translateImageFormat(ImageFormat.jpeg),
    ];
}
exports.allTranslatedValuesImageFormat = allTranslatedValuesImageFormat;
function allDisplayableValuesImageFormat() {
    return allTranslatedValuesImageFormat().sort();
}
exports.allDisplayableValuesImageFormat = allDisplayableValuesImageFormat;
function valueFromTranslationImageFormat(translation) {
    const index = allTranslatedValuesImageFormat().indexOf(translation);
    return allValuesImageFormat()[index] || ImageFormat.png;
}
exports.valueFromTranslationImageFormat = valueFromTranslationImageFormat;
var FileFormat;
(function (FileFormat) {
    FileFormat["pdf"] = "pdf";
})(FileFormat = exports.FileFormat || (exports.FileFormat = {}));
function translateFileFormat(enumFileFormat) {
    switch (enumFileFormat) {
        case FileFormat.pdf: {
            return strings ? strings["enum"]["FileFormat"]["pdf"] || FileFormat.pdf : FileFormat.pdf;
        }
    }
    return "";
}
exports.translateFileFormat = translateFileFormat;
function allValuesFileFormat() {
    return [
        FileFormat.pdf,
    ];
}
exports.allValuesFileFormat = allValuesFileFormat;
function allTranslatedValuesFileFormat() {
    return [
        translateFileFormat(FileFormat.pdf),
    ];
}
exports.allTranslatedValuesFileFormat = allTranslatedValuesFileFormat;
function allDisplayableValuesFileFormat() {
    return allTranslatedValuesFileFormat().sort();
}
exports.allDisplayableValuesFileFormat = allDisplayableValuesFileFormat;
function valueFromTranslationFileFormat(translation) {
    const index = allTranslatedValuesFileFormat().indexOf(translation);
    return allValuesFileFormat()[index] || FileFormat.pdf;
}
exports.valueFromTranslationFileFormat = valueFromTranslationFileFormat;
var ErrorType;
(function (ErrorType) {
    ErrorType["NotFound"] = "NotFound";
    ErrorType["MissingArgument"] = "MissingArgument";
    ErrorType["InvalidArgument"] = "InvalidArgument";
    ErrorType["InvalidPermission"] = "InvalidPermission";
    ErrorType["BadFormattedResponse"] = "BadFormattedResponse";
    ErrorType["InternalError"] = "InternalError";
    ErrorType["Validation"] = "Validation";
    ErrorType["EmailOrPasswordWrong"] = "EmailOrPasswordWrong";
    ErrorType["AccessNotAllowed"] = "AccessNotAllowed";
    ErrorType["NotLoggedIn"] = "NotLoggedIn";
    ErrorType["EmailAlreadyRegistered"] = "EmailAlreadyRegistered";
    ErrorType["AlreadyRegistered"] = "AlreadyRegistered";
    ErrorType["AlreadyFinished"] = "AlreadyFinished";
    ErrorType["Fatal"] = "Fatal";
    ErrorType["Connection"] = "Connection";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
function translateErrorType(enumErrorType) {
    switch (enumErrorType) {
        case ErrorType.NotFound: {
            return strings ? strings["enum"]["ErrorType"]["NotFound"] || ErrorType.NotFound : ErrorType.NotFound;
        }
        case ErrorType.MissingArgument: {
            return strings ? strings["enum"]["ErrorType"]["MissingArgument"] || ErrorType.MissingArgument : ErrorType.MissingArgument;
        }
        case ErrorType.InvalidArgument: {
            return strings ? strings["enum"]["ErrorType"]["InvalidArgument"] || ErrorType.InvalidArgument : ErrorType.InvalidArgument;
        }
        case ErrorType.InvalidPermission: {
            return strings ? strings["enum"]["ErrorType"]["InvalidPermission"] || ErrorType.InvalidPermission : ErrorType.InvalidPermission;
        }
        case ErrorType.BadFormattedResponse: {
            return strings ? strings["enum"]["ErrorType"]["BadFormattedResponse"] || ErrorType.BadFormattedResponse : ErrorType.BadFormattedResponse;
        }
        case ErrorType.InternalError: {
            return strings ? strings["enum"]["ErrorType"]["InternalError"] || ErrorType.InternalError : ErrorType.InternalError;
        }
        case ErrorType.Validation: {
            return strings ? strings["enum"]["ErrorType"]["Validation"] || ErrorType.Validation : ErrorType.Validation;
        }
        case ErrorType.EmailOrPasswordWrong: {
            return strings ? strings["enum"]["ErrorType"]["EmailOrPasswordWrong"] || ErrorType.EmailOrPasswordWrong : ErrorType.EmailOrPasswordWrong;
        }
        case ErrorType.AccessNotAllowed: {
            return strings ? strings["enum"]["ErrorType"]["AccessNotAllowed"] || ErrorType.AccessNotAllowed : ErrorType.AccessNotAllowed;
        }
        case ErrorType.NotLoggedIn: {
            return strings ? strings["enum"]["ErrorType"]["NotLoggedIn"] || ErrorType.NotLoggedIn : ErrorType.NotLoggedIn;
        }
        case ErrorType.EmailAlreadyRegistered: {
            return strings ? strings["enum"]["ErrorType"]["EmailAlreadyRegistered"] || ErrorType.EmailAlreadyRegistered : ErrorType.EmailAlreadyRegistered;
        }
        case ErrorType.AlreadyRegistered: {
            return strings ? strings["enum"]["ErrorType"]["AlreadyRegistered"] || ErrorType.AlreadyRegistered : ErrorType.AlreadyRegistered;
        }
        case ErrorType.AlreadyFinished: {
            return strings ? strings["enum"]["ErrorType"]["AlreadyFinished"] || ErrorType.AlreadyFinished : ErrorType.AlreadyFinished;
        }
        case ErrorType.Fatal: {
            return strings ? strings["enum"]["ErrorType"]["Fatal"] || ErrorType.Fatal : ErrorType.Fatal;
        }
        case ErrorType.Connection: {
            return strings ? strings["enum"]["ErrorType"]["Connection"] || ErrorType.Connection : ErrorType.Connection;
        }
    }
    return "";
}
exports.translateErrorType = translateErrorType;
function allValuesErrorType() {
    return [
        ErrorType.NotFound,
        ErrorType.MissingArgument,
        ErrorType.InvalidArgument,
        ErrorType.InvalidPermission,
        ErrorType.BadFormattedResponse,
        ErrorType.InternalError,
        ErrorType.Validation,
        ErrorType.EmailOrPasswordWrong,
        ErrorType.AccessNotAllowed,
        ErrorType.NotLoggedIn,
        ErrorType.EmailAlreadyRegistered,
        ErrorType.AlreadyRegistered,
        ErrorType.AlreadyFinished,
        ErrorType.Fatal,
        ErrorType.Connection,
    ];
}
exports.allValuesErrorType = allValuesErrorType;
function allTranslatedValuesErrorType() {
    return [
        translateErrorType(ErrorType.NotFound),
        translateErrorType(ErrorType.MissingArgument),
        translateErrorType(ErrorType.InvalidArgument),
        translateErrorType(ErrorType.InvalidPermission),
        translateErrorType(ErrorType.BadFormattedResponse),
        translateErrorType(ErrorType.InternalError),
        translateErrorType(ErrorType.Validation),
        translateErrorType(ErrorType.EmailOrPasswordWrong),
        translateErrorType(ErrorType.AccessNotAllowed),
        translateErrorType(ErrorType.NotLoggedIn),
        translateErrorType(ErrorType.EmailAlreadyRegistered),
        translateErrorType(ErrorType.AlreadyRegistered),
        translateErrorType(ErrorType.AlreadyFinished),
        translateErrorType(ErrorType.Fatal),
        translateErrorType(ErrorType.Connection),
    ];
}
exports.allTranslatedValuesErrorType = allTranslatedValuesErrorType;
function allDisplayableValuesErrorType() {
    return allTranslatedValuesErrorType().sort();
}
exports.allDisplayableValuesErrorType = allDisplayableValuesErrorType;
function valueFromTranslationErrorType(translation) {
    const index = allTranslatedValuesErrorType().indexOf(translation);
    return allValuesErrorType()[index] || ErrorType.NotFound;
}
exports.valueFromTranslationErrorType = valueFromTranslationErrorType;
async function uploadUncertainFile(file, fileFormat, options) {
    const args = {
        file: {
            bytes: file.bytes === null || file.bytes === undefined ? null : file.bytes.toString("base64"),
            url: file.url === null || file.url === undefined ? null : file.url,
        },
        fileFormat: fileFormat === null || fileFormat === undefined ? null : fileFormat,
    };
    const ret = await makeRequest({ name: "uploadUncertainFile", args, options });
    return ret;
}
exports.uploadUncertainFile = uploadUncertainFile;
async function uploadImage(image, imageFormat, options) {
    const args = {
        image: image.toString("base64"),
        imageFormat: imageFormat === null || imageFormat === undefined ? null : imageFormat,
    };
    const ret = await makeRequest({ name: "uploadImage", args, options });
    return {
        thumb: {
            width: ret.thumb.width || 0,
            height: ret.thumb.height || 0,
            url: ret.thumb.url,
        },
        width: ret.width || 0,
        height: ret.height || 0,
        url: ret.url,
    };
}
exports.uploadImage = uploadImage;
async function uploadUncertainImage(image, imageFormat, options) {
    const args = {
        image: {
            bytes: image.bytes === null || image.bytes === undefined ? null : image.bytes.toString("base64"),
            image: image.image === null || image.image === undefined ? null : {
                thumb: {
                    width: image.image.thumb.width || 0,
                    height: image.image.thumb.height || 0,
                    url: image.image.thumb.url,
                },
                width: image.image.width || 0,
                height: image.image.height || 0,
                url: image.image.url,
            },
        },
        imageFormat: imageFormat === null || imageFormat === undefined ? null : imageFormat,
    };
    const ret = await makeRequest({ name: "uploadUncertainImage", args, options });
    return {
        thumb: {
            width: ret.thumb.width || 0,
            height: ret.thumb.height || 0,
            url: ret.thumb.url,
        },
        width: ret.width || 0,
        height: ret.height || 0,
        url: ret.url,
    };
}
exports.uploadUncertainImage = uploadUncertainImage;
async function uploadUncompressedImage(image, imageFormat, options) {
    const args = {
        image: image.toString("base64"),
        imageFormat: imageFormat === null || imageFormat === undefined ? null : imageFormat,
    };
    const ret = await makeRequest({ name: "uploadUncompressedImage", args, options });
    return {
        thumb: {
            width: ret.thumb.width || 0,
            height: ret.thumb.height || 0,
            url: ret.thumb.url,
        },
        width: ret.width || 0,
        height: ret.height || 0,
        url: ret.url,
    };
}
exports.uploadUncompressedImage = uploadUncompressedImage;
async function uploadUncompressedUncertainImage(image, imageFormat, options) {
    const args = {
        image: {
            bytes: image.bytes === null || image.bytes === undefined ? null : image.bytes.toString("base64"),
            image: image.image === null || image.image === undefined ? null : {
                thumb: {
                    width: image.image.thumb.width || 0,
                    height: image.image.thumb.height || 0,
                    url: image.image.thumb.url,
                },
                width: image.image.width || 0,
                height: image.image.height || 0,
                url: image.image.url,
            },
        },
        imageFormat: imageFormat === null || imageFormat === undefined ? null : imageFormat,
    };
    const ret = await makeRequest({ name: "uploadUncompressedUncertainImage", args, options });
    return {
        thumb: {
            width: ret.thumb.width || 0,
            height: ret.thumb.height || 0,
            url: ret.thumb.url,
        },
        width: ret.width || 0,
        height: ret.height || 0,
        url: ret.url,
    };
}
exports.uploadUncompressedUncertainImage = uploadUncompressedUncertainImage;
async function getAllShowInSiteClinicAdminUsers(pageOffset, options) {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({ name: "getAllShowInSiteClinicAdminUsers", args, options });
    return ret.map((e) => ({
        id: e.id,
        clinic: e.clinic === null || e.clinic === undefined ? null : {
            id: e.clinic.id,
            image: {
                thumb: {
                    width: e.clinic.image.thumb.width || 0,
                    height: e.clinic.image.thumb.height || 0,
                    url: e.clinic.image.thumb.url,
                },
                width: e.clinic.image.width || 0,
                height: e.clinic.image.height || 0,
                url: e.clinic.image.url,
            },
            phone: e.clinic.phone,
            showInSite: !!e.clinic.showInSite,
            address: {
                zipcode: e.clinic.address.zipcode,
                street: e.clinic.address.street,
                streetNumber: e.clinic.address.streetNumber,
                complementary: e.clinic.address.complementary,
                neighborhood: e.clinic.address.neighborhood,
                city: e.clinic.address.city,
                state: e.clinic.address.state,
            },
            code: e.clinic.code || 0,
            codeFormat: e.clinic.codeFormat,
            services: e.clinic.services === null || e.clinic.services === undefined ? null : e.clinic.services,
            createdAt: new Date(e.clinic.createdAt + "Z"),
            adminUser: e.clinic.adminUser === null || e.clinic.adminUser === undefined ? null : {
                name: e.clinic.adminUser.name,
                documentNumber: e.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(e.createdAt + "Z"),
        name: e.name,
        email: e.email,
        documentNumber: e.documentNumber,
    }));
}
exports.getAllShowInSiteClinicAdminUsers = getAllShowInSiteClinicAdminUsers;
async function getOneShowInSiteClinicAdminUser(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "getOneShowInSiteClinicAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.getOneShowInSiteClinicAdminUser = getOneShowInSiteClinicAdminUser;
async function getAllVeterinaryClinicPaginated(pageOffset, options) {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({ name: "getAllVeterinaryClinicPaginated", args, options });
    return ret.map((e) => ({
        id: e.id,
        image: {
            thumb: {
                width: e.image.thumb.width || 0,
                height: e.image.thumb.height || 0,
                url: e.image.thumb.url,
            },
            width: e.image.width || 0,
            height: e.image.height || 0,
            url: e.image.url,
        },
        name: e.name,
        email: e.email,
        documentNumber: e.documentNumber,
        phone: e.phone,
        showInSite: !!e.showInSite,
        address: {
            zipcode: e.address.zipcode,
            street: e.address.street,
            streetNumber: e.address.streetNumber,
            complementary: e.address.complementary,
            neighborhood: e.address.neighborhood,
            city: e.address.city,
            state: e.address.state,
        },
        createdAt: new Date(e.createdAt + "Z"),
        code: e.code || 0,
        codeFormat: e.codeFormat,
        services: e.services === null || e.services === undefined ? null : e.services,
    }));
}
exports.getAllVeterinaryClinicPaginated = getAllVeterinaryClinicPaginated;
async function getOneVeterinaryClinicById(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "getOneVeterinaryClinicById", args, options });
    return {
        id: ret.id,
        image: {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
        phone: ret.phone,
        showInSite: !!ret.showInSite,
        address: {
            zipcode: ret.address.zipcode,
            street: ret.address.street,
            streetNumber: ret.address.streetNumber,
            complementary: ret.address.complementary,
            neighborhood: ret.address.neighborhood,
            city: ret.address.city,
            state: ret.address.state,
        },
        createdAt: new Date(ret.createdAt + "Z"),
        code: ret.code || 0,
        codeFormat: ret.codeFormat,
        services: ret.services === null || ret.services === undefined ? null : ret.services,
    };
}
exports.getOneVeterinaryClinicById = getOneVeterinaryClinicById;
async function getVetById(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "getVetById", args, options });
    return {
        id: ret.id,
        name: ret.name,
        image: ret.image === null || ret.image === undefined ? null : {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        description: ret.description === null || ret.description === undefined ? null : ret.description,
    };
}
exports.getVetById = getVetById;
async function getAllVetsShowInSite(pageOffSet, options) {
    const args = {
        pageOffSet: pageOffSet || 0,
    };
    const ret = await makeRequest({ name: "getAllVetsShowInSite", args, options });
    return ret.map((e) => ({
        id: e.id,
        name: e.name,
        image: e.image === null || e.image === undefined ? null : {
            thumb: {
                width: e.image.thumb.width || 0,
                height: e.image.thumb.height || 0,
                url: e.image.thumb.url,
            },
            width: e.image.width || 0,
            height: e.image.height || 0,
            url: e.image.url,
        },
        description: e.description === null || e.description === undefined ? null : e.description,
    }));
}
exports.getAllVetsShowInSite = getAllVetsShowInSite;
async function getAdminUser(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "getAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.getAdminUser = getAdminUser;
async function getCurrentAdminLogged(options) {
    const ret = await makeRequest({ name: "getCurrentAdminLogged", args: {}, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.getCurrentAdminLogged = getCurrentAdminLogged;
async function getAllAdminUsers(pageOffset, options) {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({ name: "getAllAdminUsers", args, options });
    return ret.map((e) => ({
        id: e.id,
        clinic: e.clinic === null || e.clinic === undefined ? null : {
            id: e.clinic.id,
            image: {
                thumb: {
                    width: e.clinic.image.thumb.width || 0,
                    height: e.clinic.image.thumb.height || 0,
                    url: e.clinic.image.thumb.url,
                },
                width: e.clinic.image.width || 0,
                height: e.clinic.image.height || 0,
                url: e.clinic.image.url,
            },
            phone: e.clinic.phone,
            showInSite: !!e.clinic.showInSite,
            address: {
                zipcode: e.clinic.address.zipcode,
                street: e.clinic.address.street,
                streetNumber: e.clinic.address.streetNumber,
                complementary: e.clinic.address.complementary,
                neighborhood: e.clinic.address.neighborhood,
                city: e.clinic.address.city,
                state: e.clinic.address.state,
            },
            code: e.clinic.code || 0,
            codeFormat: e.clinic.codeFormat,
            services: e.clinic.services === null || e.clinic.services === undefined ? null : e.clinic.services,
            createdAt: new Date(e.clinic.createdAt + "Z"),
            adminUser: e.clinic.adminUser === null || e.clinic.adminUser === undefined ? null : {
                name: e.clinic.adminUser.name,
                documentNumber: e.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(e.createdAt + "Z"),
        name: e.name,
        email: e.email,
        documentNumber: e.documentNumber,
    }));
}
exports.getAllAdminUsers = getAllAdminUsers;
async function createAdminUser(newAdminUser, options) {
    const args = {
        newAdminUser: {
            password: newAdminUser.password,
            name: newAdminUser.name,
            email: newAdminUser.email,
            documentNumber: newAdminUser.documentNumber,
        },
    };
    const ret = await makeRequest({ name: "createAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.createAdminUser = createAdminUser;
async function editAdminUser(id, editAdminUser, options) {
    const args = {
        id: id,
        editAdminUser: {
            name: editAdminUser.name,
            email: editAdminUser.email,
            documentNumber: editAdminUser.documentNumber,
        },
    };
    const ret = await makeRequest({ name: "editAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.editAdminUser = editAdminUser;
async function deleteAdminUser(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "deleteAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.deleteAdminUser = deleteAdminUser;
async function adminLogin(email, password, options) {
    const args = {
        email: email,
        password: password,
    };
    const ret = await makeRequest({ name: "adminLogin", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.adminLogin = adminLogin;
async function logoutAdminUser(options) {
    await makeRequest({ name: "logoutAdminUser", args: {}, options });
    return undefined;
}
exports.logoutAdminUser = logoutAdminUser;
async function createClinicAdminUser(newClinic, options) {
    const args = {
        newClinic: {
            clinic: {
                image: newClinic.clinic.image === null || newClinic.clinic.image === undefined ? null : {
                    bytes: newClinic.clinic.image.bytes === null || newClinic.clinic.image.bytes === undefined ? null : newClinic.clinic.image.bytes.toString("base64"),
                    image: newClinic.clinic.image.image === null || newClinic.clinic.image.image === undefined ? null : {
                        thumb: {
                            width: newClinic.clinic.image.image.thumb.width || 0,
                            height: newClinic.clinic.image.image.thumb.height || 0,
                            url: newClinic.clinic.image.image.thumb.url,
                        },
                        width: newClinic.clinic.image.image.width || 0,
                        height: newClinic.clinic.image.image.height || 0,
                        url: newClinic.clinic.image.image.url,
                    },
                },
                phone: newClinic.clinic.phone,
                address: {
                    zipcode: newClinic.clinic.address.zipcode,
                    street: newClinic.clinic.address.street,
                    streetNumber: newClinic.clinic.address.streetNumber,
                    complementary: newClinic.clinic.address.complementary,
                    neighborhood: newClinic.clinic.address.neighborhood,
                    city: newClinic.clinic.address.city,
                    state: newClinic.clinic.address.state,
                },
            },
            password: newClinic.password,
            name: newClinic.name,
            email: newClinic.email,
            documentNumber: newClinic.documentNumber,
        },
    };
    const ret = await makeRequest({ name: "createClinicAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.createClinicAdminUser = createClinicAdminUser;
async function editClinicAdminUser(id, editClinic, options) {
    const args = {
        id: id,
        editClinic: {
            clinic: {
                image: editClinic.clinic.image === null || editClinic.clinic.image === undefined ? null : {
                    bytes: editClinic.clinic.image.bytes === null || editClinic.clinic.image.bytes === undefined ? null : editClinic.clinic.image.bytes.toString("base64"),
                    image: editClinic.clinic.image.image === null || editClinic.clinic.image.image === undefined ? null : {
                        thumb: {
                            width: editClinic.clinic.image.image.thumb.width || 0,
                            height: editClinic.clinic.image.image.thumb.height || 0,
                            url: editClinic.clinic.image.image.thumb.url,
                        },
                        width: editClinic.clinic.image.image.width || 0,
                        height: editClinic.clinic.image.image.height || 0,
                        url: editClinic.clinic.image.image.url,
                    },
                },
                phone: editClinic.clinic.phone,
                address: {
                    zipcode: editClinic.clinic.address.zipcode,
                    street: editClinic.clinic.address.street,
                    streetNumber: editClinic.clinic.address.streetNumber,
                    complementary: editClinic.clinic.address.complementary,
                    neighborhood: editClinic.clinic.address.neighborhood,
                    city: editClinic.clinic.address.city,
                    state: editClinic.clinic.address.state,
                },
            },
            name: editClinic.name,
            email: editClinic.email,
            documentNumber: editClinic.documentNumber,
        },
    };
    const ret = await makeRequest({ name: "editClinicAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.editClinicAdminUser = editClinicAdminUser;
async function editCurrentClinicAdminUser(editClinic, options) {
    const args = {
        editClinic: {
            clinic: {
                image: editClinic.clinic.image === null || editClinic.clinic.image === undefined ? null : {
                    bytes: editClinic.clinic.image.bytes === null || editClinic.clinic.image.bytes === undefined ? null : editClinic.clinic.image.bytes.toString("base64"),
                    image: editClinic.clinic.image.image === null || editClinic.clinic.image.image === undefined ? null : {
                        thumb: {
                            width: editClinic.clinic.image.image.thumb.width || 0,
                            height: editClinic.clinic.image.image.thumb.height || 0,
                            url: editClinic.clinic.image.image.thumb.url,
                        },
                        width: editClinic.clinic.image.image.width || 0,
                        height: editClinic.clinic.image.image.height || 0,
                        url: editClinic.clinic.image.image.url,
                    },
                },
                phone: editClinic.clinic.phone,
                address: {
                    zipcode: editClinic.clinic.address.zipcode,
                    street: editClinic.clinic.address.street,
                    streetNumber: editClinic.clinic.address.streetNumber,
                    complementary: editClinic.clinic.address.complementary,
                    neighborhood: editClinic.clinic.address.neighborhood,
                    city: editClinic.clinic.address.city,
                    state: editClinic.clinic.address.state,
                },
            },
            password: editClinic.password,
            name: editClinic.name,
            email: editClinic.email,
            documentNumber: editClinic.documentNumber,
        },
    };
    const ret = await makeRequest({ name: "editCurrentClinicAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.editCurrentClinicAdminUser = editCurrentClinicAdminUser;
async function getAllClinicAdminUsers(pageOffset, options) {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({ name: "getAllClinicAdminUsers", args, options });
    return ret.map((e) => ({
        id: e.id,
        clinic: e.clinic === null || e.clinic === undefined ? null : {
            id: e.clinic.id,
            image: {
                thumb: {
                    width: e.clinic.image.thumb.width || 0,
                    height: e.clinic.image.thumb.height || 0,
                    url: e.clinic.image.thumb.url,
                },
                width: e.clinic.image.width || 0,
                height: e.clinic.image.height || 0,
                url: e.clinic.image.url,
            },
            phone: e.clinic.phone,
            showInSite: !!e.clinic.showInSite,
            address: {
                zipcode: e.clinic.address.zipcode,
                street: e.clinic.address.street,
                streetNumber: e.clinic.address.streetNumber,
                complementary: e.clinic.address.complementary,
                neighborhood: e.clinic.address.neighborhood,
                city: e.clinic.address.city,
                state: e.clinic.address.state,
            },
            code: e.clinic.code || 0,
            codeFormat: e.clinic.codeFormat,
            services: e.clinic.services === null || e.clinic.services === undefined ? null : e.clinic.services,
            createdAt: new Date(e.clinic.createdAt + "Z"),
            adminUser: e.clinic.adminUser === null || e.clinic.adminUser === undefined ? null : {
                name: e.clinic.adminUser.name,
                documentNumber: e.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(e.createdAt + "Z"),
        name: e.name,
        email: e.email,
        documentNumber: e.documentNumber,
    }));
}
exports.getAllClinicAdminUsers = getAllClinicAdminUsers;
async function createClinicAdminUserToShowInSite(newClinic, options) {
    const args = {
        newClinic: {
            clinic: {
                phone: newClinic.clinic.phone,
                image: {
                    bytes: newClinic.clinic.image.bytes === null || newClinic.clinic.image.bytes === undefined ? null : newClinic.clinic.image.bytes.toString("base64"),
                    image: newClinic.clinic.image.image === null || newClinic.clinic.image.image === undefined ? null : {
                        thumb: {
                            width: newClinic.clinic.image.image.thumb.width || 0,
                            height: newClinic.clinic.image.image.thumb.height || 0,
                            url: newClinic.clinic.image.image.thumb.url,
                        },
                        width: newClinic.clinic.image.image.width || 0,
                        height: newClinic.clinic.image.image.height || 0,
                        url: newClinic.clinic.image.image.url,
                    },
                },
                services: newClinic.clinic.services,
                address: {
                    zipcode: newClinic.clinic.address.zipcode,
                    street: newClinic.clinic.address.street,
                    streetNumber: newClinic.clinic.address.streetNumber,
                    complementary: newClinic.clinic.address.complementary,
                    neighborhood: newClinic.clinic.address.neighborhood,
                    city: newClinic.clinic.address.city,
                    state: newClinic.clinic.address.state,
                },
            },
            name: newClinic.name,
            email: newClinic.email,
            documentNumber: newClinic.documentNumber,
        },
    };
    const ret = await makeRequest({ name: "createClinicAdminUserToShowInSite", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.createClinicAdminUserToShowInSite = createClinicAdminUserToShowInSite;
async function editShowInSiteClinicAdminUser(id, editClinic, options) {
    const args = {
        id: id,
        editClinic: {
            clinic: {
                phone: editClinic.clinic.phone,
                image: {
                    bytes: editClinic.clinic.image.bytes === null || editClinic.clinic.image.bytes === undefined ? null : editClinic.clinic.image.bytes.toString("base64"),
                    image: editClinic.clinic.image.image === null || editClinic.clinic.image.image === undefined ? null : {
                        thumb: {
                            width: editClinic.clinic.image.image.thumb.width || 0,
                            height: editClinic.clinic.image.image.thumb.height || 0,
                            url: editClinic.clinic.image.image.thumb.url,
                        },
                        width: editClinic.clinic.image.image.width || 0,
                        height: editClinic.clinic.image.image.height || 0,
                        url: editClinic.clinic.image.image.url,
                    },
                },
                services: editClinic.clinic.services,
                address: {
                    zipcode: editClinic.clinic.address.zipcode,
                    street: editClinic.clinic.address.street,
                    streetNumber: editClinic.clinic.address.streetNumber,
                    complementary: editClinic.clinic.address.complementary,
                    neighborhood: editClinic.clinic.address.neighborhood,
                    city: editClinic.clinic.address.city,
                    state: editClinic.clinic.address.state,
                },
            },
            name: editClinic.name,
            email: editClinic.email,
            documentNumber: editClinic.documentNumber,
        },
    };
    const ret = await makeRequest({ name: "editShowInSiteClinicAdminUser", args, options });
    return {
        id: ret.id,
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
        createdAt: new Date(ret.createdAt + "Z"),
        name: ret.name,
        email: ret.email,
        documentNumber: ret.documentNumber,
    };
}
exports.editShowInSiteClinicAdminUser = editShowInSiteClinicAdminUser;
async function getAllMyConsultations(pageOffset, options) {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({ name: "getAllMyConsultations", args, options });
    return ret.map((e) => ({
        id: e.id,
        user: {
            id: e.user.id,
            email: e.user.email,
            name: e.user.name,
            password: e.user.password,
            documentNumber: e.user.documentNumber,
            phone: e.user.phone,
            image: e.user.image === null || e.user.image === undefined ? null : {
                thumb: {
                    width: e.user.image.thumb.width || 0,
                    height: e.user.image.thumb.height || 0,
                    url: e.user.image.thumb.url,
                },
                width: e.user.image.width || 0,
                height: e.user.image.height || 0,
                url: e.user.image.url,
            },
            petParents: e.user.petParents,
        },
        pet: {
            id: e.pet.id,
            name: e.pet.name,
            image: {
                thumb: {
                    width: e.pet.image.thumb.width || 0,
                    height: e.pet.image.thumb.height || 0,
                    url: e.pet.image.thumb.url,
                },
                width: e.pet.image.width || 0,
                height: e.pet.image.height || 0,
                url: e.pet.image.url,
            },
            age: e.pet.age,
            species: e.pet.species,
            animalSex: e.pet.animalSex,
            isCastrated: !!e.pet.isCastrated,
            code: e.pet.code || 0,
            breed: e.pet.breed,
            birthdate: new Date(e.pet.birthdate + "Z"),
            codeFormat: e.pet.codeFormat,
        },
        vet: {
            id: e.vet.id,
            name: e.vet.name,
            image: e.vet.image === null || e.vet.image === undefined ? null : {
                thumb: {
                    width: e.vet.image.thumb.width || 0,
                    height: e.vet.image.thumb.height || 0,
                    url: e.vet.image.thumb.url,
                },
                width: e.vet.image.width || 0,
                height: e.vet.image.height || 0,
                url: e.vet.image.url,
            },
            description: e.vet.description === null || e.vet.description === undefined ? null : e.vet.description,
        },
        date: new Date(e.date + "Z"),
        hour: e.hour,
        description: e.description,
        clinic: {
            id: e.clinic.id,
            image: {
                thumb: {
                    width: e.clinic.image.thumb.width || 0,
                    height: e.clinic.image.thumb.height || 0,
                    url: e.clinic.image.thumb.url,
                },
                width: e.clinic.image.width || 0,
                height: e.clinic.image.height || 0,
                url: e.clinic.image.url,
            },
            phone: e.clinic.phone,
            showInSite: !!e.clinic.showInSite,
            address: {
                zipcode: e.clinic.address.zipcode,
                street: e.clinic.address.street,
                streetNumber: e.clinic.address.streetNumber,
                complementary: e.clinic.address.complementary,
                neighborhood: e.clinic.address.neighborhood,
                city: e.clinic.address.city,
                state: e.clinic.address.state,
            },
            code: e.clinic.code || 0,
            codeFormat: e.clinic.codeFormat,
            services: e.clinic.services === null || e.clinic.services === undefined ? null : e.clinic.services,
            createdAt: new Date(e.clinic.createdAt + "Z"),
            adminUser: e.clinic.adminUser === null || e.clinic.adminUser === undefined ? null : {
                name: e.clinic.adminUser.name,
                documentNumber: e.clinic.adminUser.documentNumber,
            },
        },
        finishedAt: e.finishedAt === null || e.finishedAt === undefined ? null : new Date(e.finishedAt + "Z"),
    }));
}
exports.getAllMyConsultations = getAllMyConsultations;
async function createContact(newContact, options) {
    const args = {
        newContact: {
            name: newContact.name,
            email: newContact.email,
            phone: newContact.phone,
            message: newContact.message,
        },
    };
    const ret = await makeRequest({ name: "createContact", args, options });
    return {
        id: ret.id,
        name: ret.name,
        email: ret.email,
        phone: ret.phone,
        message: ret.message,
    };
}
exports.createContact = createContact;
async function getAllMyHospitalizations(pageOffset, options) {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({ name: "getAllMyHospitalizations", args, options });
    return ret.map((e) => ({
        id: e.id,
        startDate: new Date(e.startDate + "Z"),
        endDate: e.endDate === null || e.endDate === undefined ? null : new Date(e.endDate + "Z"),
        entryTime: e.entryTime,
        exitTime: e.exitTime === null || e.exitTime === undefined ? null : e.exitTime,
        images: e.images.map((e) => ({
            thumb: {
                width: e.thumb.width || 0,
                height: e.thumb.height || 0,
                url: e.thumb.url,
            },
            width: e.width || 0,
            height: e.height || 0,
            url: e.url,
        })),
        pet: {
            id: e.pet.id,
            name: e.pet.name,
            image: {
                thumb: {
                    width: e.pet.image.thumb.width || 0,
                    height: e.pet.image.thumb.height || 0,
                    url: e.pet.image.thumb.url,
                },
                width: e.pet.image.width || 0,
                height: e.pet.image.height || 0,
                url: e.pet.image.url,
            },
            age: e.pet.age,
            species: e.pet.species,
            animalSex: e.pet.animalSex,
            isCastrated: !!e.pet.isCastrated,
            code: e.pet.code || 0,
            breed: e.pet.breed,
            birthdate: new Date(e.pet.birthdate + "Z"),
            codeFormat: e.pet.codeFormat,
        },
        clinic: e.clinic === null || e.clinic === undefined ? null : {
            id: e.clinic.id,
            image: {
                thumb: {
                    width: e.clinic.image.thumb.width || 0,
                    height: e.clinic.image.thumb.height || 0,
                    url: e.clinic.image.thumb.url,
                },
                width: e.clinic.image.width || 0,
                height: e.clinic.image.height || 0,
                url: e.clinic.image.url,
            },
            phone: e.clinic.phone,
            showInSite: !!e.clinic.showInSite,
            address: {
                zipcode: e.clinic.address.zipcode,
                street: e.clinic.address.street,
                streetNumber: e.clinic.address.streetNumber,
                complementary: e.clinic.address.complementary,
                neighborhood: e.clinic.address.neighborhood,
                city: e.clinic.address.city,
                state: e.clinic.address.state,
            },
            code: e.clinic.code || 0,
            codeFormat: e.clinic.codeFormat,
            services: e.clinic.services === null || e.clinic.services === undefined ? null : e.clinic.services,
            createdAt: new Date(e.clinic.createdAt + "Z"),
            adminUser: e.clinic.adminUser === null || e.clinic.adminUser === undefined ? null : {
                name: e.clinic.adminUser.name,
                documentNumber: e.clinic.adminUser.documentNumber,
            },
        },
    }));
}
exports.getAllMyHospitalizations = getAllMyHospitalizations;
async function getHospitalizationById(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "getHospitalizationById", args, options });
    return {
        id: ret.id,
        startDate: new Date(ret.startDate + "Z"),
        endDate: ret.endDate === null || ret.endDate === undefined ? null : new Date(ret.endDate + "Z"),
        entryTime: ret.entryTime,
        exitTime: ret.exitTime === null || ret.exitTime === undefined ? null : ret.exitTime,
        images: ret.images.map((e) => ({
            thumb: {
                width: e.thumb.width || 0,
                height: e.thumb.height || 0,
                url: e.thumb.url,
            },
            width: e.width || 0,
            height: e.height || 0,
            url: e.url,
        })),
        pet: {
            id: ret.pet.id,
            name: ret.pet.name,
            image: {
                thumb: {
                    width: ret.pet.image.thumb.width || 0,
                    height: ret.pet.image.thumb.height || 0,
                    url: ret.pet.image.thumb.url,
                },
                width: ret.pet.image.width || 0,
                height: ret.pet.image.height || 0,
                url: ret.pet.image.url,
            },
            age: ret.pet.age,
            species: ret.pet.species,
            animalSex: ret.pet.animalSex,
            isCastrated: !!ret.pet.isCastrated,
            code: ret.pet.code || 0,
            breed: ret.pet.breed,
            birthdate: new Date(ret.pet.birthdate + "Z"),
            codeFormat: ret.pet.codeFormat,
        },
        clinic: ret.clinic === null || ret.clinic === undefined ? null : {
            id: ret.clinic.id,
            image: {
                thumb: {
                    width: ret.clinic.image.thumb.width || 0,
                    height: ret.clinic.image.thumb.height || 0,
                    url: ret.clinic.image.thumb.url,
                },
                width: ret.clinic.image.width || 0,
                height: ret.clinic.image.height || 0,
                url: ret.clinic.image.url,
            },
            phone: ret.clinic.phone,
            showInSite: !!ret.clinic.showInSite,
            address: {
                zipcode: ret.clinic.address.zipcode,
                street: ret.clinic.address.street,
                streetNumber: ret.clinic.address.streetNumber,
                complementary: ret.clinic.address.complementary,
                neighborhood: ret.clinic.address.neighborhood,
                city: ret.clinic.address.city,
                state: ret.clinic.address.state,
            },
            code: ret.clinic.code || 0,
            codeFormat: ret.clinic.codeFormat,
            services: ret.clinic.services === null || ret.clinic.services === undefined ? null : ret.clinic.services,
            createdAt: new Date(ret.clinic.createdAt + "Z"),
            adminUser: ret.clinic.adminUser === null || ret.clinic.adminUser === undefined ? null : {
                name: ret.clinic.adminUser.name,
                documentNumber: ret.clinic.adminUser.documentNumber,
            },
        },
    };
}
exports.getHospitalizationById = getHospitalizationById;
async function getAllHospitalizationForUserByPet(pageOffset, petId, options) {
    const args = {
        pageOffset: pageOffset || 0,
        petId: petId,
    };
    const ret = await makeRequest({ name: "getAllHospitalizationForUserByPet", args, options });
    return ret.map((e) => ({
        id: e.id,
        startDate: new Date(e.startDate + "Z"),
        endDate: e.endDate === null || e.endDate === undefined ? null : new Date(e.endDate + "Z"),
        entryTime: e.entryTime,
        exitTime: e.exitTime === null || e.exitTime === undefined ? null : e.exitTime,
        images: e.images.map((e) => ({
            thumb: {
                width: e.thumb.width || 0,
                height: e.thumb.height || 0,
                url: e.thumb.url,
            },
            width: e.width || 0,
            height: e.height || 0,
            url: e.url,
        })),
        pet: {
            id: e.pet.id,
            name: e.pet.name,
            image: {
                thumb: {
                    width: e.pet.image.thumb.width || 0,
                    height: e.pet.image.thumb.height || 0,
                    url: e.pet.image.thumb.url,
                },
                width: e.pet.image.width || 0,
                height: e.pet.image.height || 0,
                url: e.pet.image.url,
            },
            age: e.pet.age,
            species: e.pet.species,
            animalSex: e.pet.animalSex,
            isCastrated: !!e.pet.isCastrated,
            code: e.pet.code || 0,
            breed: e.pet.breed,
            birthdate: new Date(e.pet.birthdate + "Z"),
            codeFormat: e.pet.codeFormat,
        },
        clinic: e.clinic === null || e.clinic === undefined ? null : {
            id: e.clinic.id,
            image: {
                thumb: {
                    width: e.clinic.image.thumb.width || 0,
                    height: e.clinic.image.thumb.height || 0,
                    url: e.clinic.image.thumb.url,
                },
                width: e.clinic.image.width || 0,
                height: e.clinic.image.height || 0,
                url: e.clinic.image.url,
            },
            phone: e.clinic.phone,
            showInSite: !!e.clinic.showInSite,
            address: {
                zipcode: e.clinic.address.zipcode,
                street: e.clinic.address.street,
                streetNumber: e.clinic.address.streetNumber,
                complementary: e.clinic.address.complementary,
                neighborhood: e.clinic.address.neighborhood,
                city: e.clinic.address.city,
                state: e.clinic.address.state,
            },
            code: e.clinic.code || 0,
            codeFormat: e.clinic.codeFormat,
            services: e.clinic.services === null || e.clinic.services === undefined ? null : e.clinic.services,
            createdAt: new Date(e.clinic.createdAt + "Z"),
            adminUser: e.clinic.adminUser === null || e.clinic.adminUser === undefined ? null : {
                name: e.clinic.adminUser.name,
                documentNumber: e.clinic.adminUser.documentNumber,
            },
        },
    }));
}
exports.getAllHospitalizationForUserByPet = getAllHospitalizationForUserByPet;
async function getHistoryByPet(petId, options) {
    const args = {
        petId: petId,
    };
    const ret = await makeRequest({ name: "getHistoryByPet", args, options });
    return {
        exams: ret.exams.map((e) => ({
            id: e.id,
            name: e.name,
            code: e.code === null || e.code === undefined ? null : e.code || 0,
            type: e.type,
            image: e.image === null || e.image === undefined ? null : {
                thumb: {
                    width: e.image.thumb.width || 0,
                    height: e.image.thumb.height || 0,
                    url: e.image.thumb.url,
                },
                width: e.image.width || 0,
                height: e.image.height || 0,
                url: e.image.url,
            },
            pdf: e.pdf === null || e.pdf === undefined ? null : e.pdf,
            createdAt: e.createdAt === null || e.createdAt === undefined ? null : new Date(e.createdAt + "Z"),
        })),
        vaccines: ret.vaccines.map((e) => ({
            id: e.id,
            name: e.name,
            code: e.code === null || e.code === undefined ? null : e.code || 0,
            nextVaccinationAt: e.nextVaccinationAt === null || e.nextVaccinationAt === undefined ? null : new Date(e.nextVaccinationAt + "Z"),
            appliedAt: new Date(e.appliedAt + "Z"),
            createdAt: new Date(e.createdAt + "Z"),
        })),
        consultations: ret.consultations.map((e) => ({
            id: e.id,
            user: {
                id: e.user.id,
                email: e.user.email,
                name: e.user.name,
                password: e.user.password,
                documentNumber: e.user.documentNumber,
                phone: e.user.phone,
                image: e.user.image === null || e.user.image === undefined ? null : {
                    thumb: {
                        width: e.user.image.thumb.width || 0,
                        height: e.user.image.thumb.height || 0,
                        url: e.user.image.thumb.url,
                    },
                    width: e.user.image.width || 0,
                    height: e.user.image.height || 0,
                    url: e.user.image.url,
                },
                petParents: e.user.petParents,
            },
            pet: {
                id: e.pet.id,
                name: e.pet.name,
                image: {
                    thumb: {
                        width: e.pet.image.thumb.width || 0,
                        height: e.pet.image.thumb.height || 0,
                        url: e.pet.image.thumb.url,
                    },
                    width: e.pet.image.width || 0,
                    height: e.pet.image.height || 0,
                    url: e.pet.image.url,
                },
                age: e.pet.age,
                species: e.pet.species,
                animalSex: e.pet.animalSex,
                isCastrated: !!e.pet.isCastrated,
                code: e.pet.code || 0,
                breed: e.pet.breed,
                birthdate: new Date(e.pet.birthdate + "Z"),
                codeFormat: e.pet.codeFormat,
            },
            vet: {
                id: e.vet.id,
                name: e.vet.name,
                image: e.vet.image === null || e.vet.image === undefined ? null : {
                    thumb: {
                        width: e.vet.image.thumb.width || 0,
                        height: e.vet.image.thumb.height || 0,
                        url: e.vet.image.thumb.url,
                    },
                    width: e.vet.image.width || 0,
                    height: e.vet.image.height || 0,
                    url: e.vet.image.url,
                },
                description: e.vet.description === null || e.vet.description === undefined ? null : e.vet.description,
            },
            date: new Date(e.date + "Z"),
            hour: e.hour,
            description: e.description,
            clinic: {
                id: e.clinic.id,
                image: {
                    thumb: {
                        width: e.clinic.image.thumb.width || 0,
                        height: e.clinic.image.thumb.height || 0,
                        url: e.clinic.image.thumb.url,
                    },
                    width: e.clinic.image.width || 0,
                    height: e.clinic.image.height || 0,
                    url: e.clinic.image.url,
                },
                phone: e.clinic.phone,
                showInSite: !!e.clinic.showInSite,
                address: {
                    zipcode: e.clinic.address.zipcode,
                    street: e.clinic.address.street,
                    streetNumber: e.clinic.address.streetNumber,
                    complementary: e.clinic.address.complementary,
                    neighborhood: e.clinic.address.neighborhood,
                    city: e.clinic.address.city,
                    state: e.clinic.address.state,
                },
                code: e.clinic.code || 0,
                codeFormat: e.clinic.codeFormat,
                services: e.clinic.services === null || e.clinic.services === undefined ? null : e.clinic.services,
                createdAt: new Date(e.clinic.createdAt + "Z"),
                adminUser: e.clinic.adminUser === null || e.clinic.adminUser === undefined ? null : {
                    name: e.clinic.adminUser.name,
                    documentNumber: e.clinic.adminUser.documentNumber,
                },
            },
            finishedAt: e.finishedAt === null || e.finishedAt === undefined ? null : new Date(e.finishedAt + "Z"),
        })),
        administeredMedications: ret.administeredMedications.map((e) => ({
            id: e.id,
            name: e.name,
            code: e.code === null || e.code === undefined ? null : e.code || 0,
            startConsumptionDate: new Date(e.startConsumptionDate + "Z"),
            endConsumptionDate: new Date(e.endConsumptionDate + "Z"),
            consumptionHours: e.consumptionHours.map((e) => new Date(e + "Z")),
            dosage: e.dosage,
            image: e.image === null || e.image === undefined ? null : {
                thumb: {
                    width: e.image.thumb.width || 0,
                    height: e.image.thumb.height || 0,
                    url: e.image.thumb.url,
                },
                width: e.image.width || 0,
                height: e.image.height || 0,
                url: e.image.url,
            },
            document: e.document === null || e.document === undefined ? null : e.document,
            createdAt: new Date(e.createdAt + "Z"),
        })),
        hospitalizations: ret.hospitalizations.map((e) => ({
            id: e.id,
            startDate: new Date(e.startDate + "Z"),
            endDate: e.endDate === null || e.endDate === undefined ? null : new Date(e.endDate + "Z"),
            entryTime: e.entryTime,
            exitTime: e.exitTime === null || e.exitTime === undefined ? null : e.exitTime,
            images: e.images.map((e) => ({
                thumb: {
                    width: e.thumb.width || 0,
                    height: e.thumb.height || 0,
                    url: e.thumb.url,
                },
                width: e.width || 0,
                height: e.height || 0,
                url: e.url,
            })),
            pet: {
                id: e.pet.id,
                name: e.pet.name,
                image: {
                    thumb: {
                        width: e.pet.image.thumb.width || 0,
                        height: e.pet.image.thumb.height || 0,
                        url: e.pet.image.thumb.url,
                    },
                    width: e.pet.image.width || 0,
                    height: e.pet.image.height || 0,
                    url: e.pet.image.url,
                },
                age: e.pet.age,
                species: e.pet.species,
                animalSex: e.pet.animalSex,
                isCastrated: !!e.pet.isCastrated,
                code: e.pet.code || 0,
                breed: e.pet.breed,
                birthdate: new Date(e.pet.birthdate + "Z"),
                codeFormat: e.pet.codeFormat,
            },
            clinic: e.clinic === null || e.clinic === undefined ? null : {
                id: e.clinic.id,
                image: {
                    thumb: {
                        width: e.clinic.image.thumb.width || 0,
                        height: e.clinic.image.thumb.height || 0,
                        url: e.clinic.image.thumb.url,
                    },
                    width: e.clinic.image.width || 0,
                    height: e.clinic.image.height || 0,
                    url: e.clinic.image.url,
                },
                phone: e.clinic.phone,
                showInSite: !!e.clinic.showInSite,
                address: {
                    zipcode: e.clinic.address.zipcode,
                    street: e.clinic.address.street,
                    streetNumber: e.clinic.address.streetNumber,
                    complementary: e.clinic.address.complementary,
                    neighborhood: e.clinic.address.neighborhood,
                    city: e.clinic.address.city,
                    state: e.clinic.address.state,
                },
                code: e.clinic.code || 0,
                codeFormat: e.clinic.codeFormat,
                services: e.clinic.services === null || e.clinic.services === undefined ? null : e.clinic.services,
                createdAt: new Date(e.clinic.createdAt + "Z"),
                adminUser: e.clinic.adminUser === null || e.clinic.adminUser === undefined ? null : {
                    name: e.clinic.adminUser.name,
                    documentNumber: e.clinic.adminUser.documentNumber,
                },
            },
        })),
    };
}
exports.getHistoryByPet = getHistoryByPet;
async function getPostById(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "getPostById", args, options });
    return {
        id: ret.id,
        image: {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        title: ret.title,
        slug: ret.slug === null || ret.slug === undefined ? null : ret.slug,
        description: ret.description,
        clinicUser: ret.clinicUser === null || ret.clinicUser === undefined ? null : {
            id: ret.clinicUser.id,
            clinic: ret.clinicUser.clinic === null || ret.clinicUser.clinic === undefined ? null : {
                id: ret.clinicUser.clinic.id,
                image: {
                    thumb: {
                        width: ret.clinicUser.clinic.image.thumb.width || 0,
                        height: ret.clinicUser.clinic.image.thumb.height || 0,
                        url: ret.clinicUser.clinic.image.thumb.url,
                    },
                    width: ret.clinicUser.clinic.image.width || 0,
                    height: ret.clinicUser.clinic.image.height || 0,
                    url: ret.clinicUser.clinic.image.url,
                },
                phone: ret.clinicUser.clinic.phone,
                showInSite: !!ret.clinicUser.clinic.showInSite,
                address: {
                    zipcode: ret.clinicUser.clinic.address.zipcode,
                    street: ret.clinicUser.clinic.address.street,
                    streetNumber: ret.clinicUser.clinic.address.streetNumber,
                    complementary: ret.clinicUser.clinic.address.complementary,
                    neighborhood: ret.clinicUser.clinic.address.neighborhood,
                    city: ret.clinicUser.clinic.address.city,
                    state: ret.clinicUser.clinic.address.state,
                },
                code: ret.clinicUser.clinic.code || 0,
                codeFormat: ret.clinicUser.clinic.codeFormat,
                services: ret.clinicUser.clinic.services === null || ret.clinicUser.clinic.services === undefined ? null : ret.clinicUser.clinic.services,
                createdAt: new Date(ret.clinicUser.clinic.createdAt + "Z"),
                adminUser: ret.clinicUser.clinic.adminUser === null || ret.clinicUser.clinic.adminUser === undefined ? null : {
                    name: ret.clinicUser.clinic.adminUser.name,
                    documentNumber: ret.clinicUser.clinic.adminUser.documentNumber,
                },
            },
            createdAt: new Date(ret.clinicUser.createdAt + "Z"),
            name: ret.clinicUser.name,
            email: ret.clinicUser.email,
            documentNumber: ret.clinicUser.documentNumber,
        },
        createdAt: new Date(ret.createdAt + "Z"),
    };
}
exports.getPostById = getPostById;
async function getAllPosts(pageOffSet, options) {
    const args = {
        pageOffSet: pageOffSet || 0,
    };
    const ret = await makeRequest({ name: "getAllPosts", args, options });
    return ret.map((e) => ({
        id: e.id,
        image: {
            thumb: {
                width: e.image.thumb.width || 0,
                height: e.image.thumb.height || 0,
                url: e.image.thumb.url,
            },
            width: e.image.width || 0,
            height: e.image.height || 0,
            url: e.image.url,
        },
        title: e.title,
        slug: e.slug === null || e.slug === undefined ? null : e.slug,
        description: e.description,
        clinicUser: e.clinicUser === null || e.clinicUser === undefined ? null : {
            id: e.clinicUser.id,
            clinic: e.clinicUser.clinic === null || e.clinicUser.clinic === undefined ? null : {
                id: e.clinicUser.clinic.id,
                image: {
                    thumb: {
                        width: e.clinicUser.clinic.image.thumb.width || 0,
                        height: e.clinicUser.clinic.image.thumb.height || 0,
                        url: e.clinicUser.clinic.image.thumb.url,
                    },
                    width: e.clinicUser.clinic.image.width || 0,
                    height: e.clinicUser.clinic.image.height || 0,
                    url: e.clinicUser.clinic.image.url,
                },
                phone: e.clinicUser.clinic.phone,
                showInSite: !!e.clinicUser.clinic.showInSite,
                address: {
                    zipcode: e.clinicUser.clinic.address.zipcode,
                    street: e.clinicUser.clinic.address.street,
                    streetNumber: e.clinicUser.clinic.address.streetNumber,
                    complementary: e.clinicUser.clinic.address.complementary,
                    neighborhood: e.clinicUser.clinic.address.neighborhood,
                    city: e.clinicUser.clinic.address.city,
                    state: e.clinicUser.clinic.address.state,
                },
                code: e.clinicUser.clinic.code || 0,
                codeFormat: e.clinicUser.clinic.codeFormat,
                services: e.clinicUser.clinic.services === null || e.clinicUser.clinic.services === undefined ? null : e.clinicUser.clinic.services,
                createdAt: new Date(e.clinicUser.clinic.createdAt + "Z"),
                adminUser: e.clinicUser.clinic.adminUser === null || e.clinicUser.clinic.adminUser === undefined ? null : {
                    name: e.clinicUser.clinic.adminUser.name,
                    documentNumber: e.clinicUser.clinic.adminUser.documentNumber,
                },
            },
            createdAt: new Date(e.clinicUser.createdAt + "Z"),
            name: e.clinicUser.name,
            email: e.clinicUser.email,
            documentNumber: e.clinicUser.documentNumber,
        },
        createdAt: new Date(e.createdAt + "Z"),
    }));
}
exports.getAllPosts = getAllPosts;
async function getHomeData(options) {
    const ret = await makeRequest({ name: "getHomeData", args: {}, options });
    return {
        posts: ret.posts.map((e) => ({
            id: e.id,
            image: {
                thumb: {
                    width: e.image.thumb.width || 0,
                    height: e.image.thumb.height || 0,
                    url: e.image.thumb.url,
                },
                width: e.image.width || 0,
                height: e.image.height || 0,
                url: e.image.url,
            },
            title: e.title,
            slug: e.slug === null || e.slug === undefined ? null : e.slug,
            description: e.description,
            clinicUser: e.clinicUser === null || e.clinicUser === undefined ? null : {
                id: e.clinicUser.id,
                clinic: e.clinicUser.clinic === null || e.clinicUser.clinic === undefined ? null : {
                    id: e.clinicUser.clinic.id,
                    image: {
                        thumb: {
                            width: e.clinicUser.clinic.image.thumb.width || 0,
                            height: e.clinicUser.clinic.image.thumb.height || 0,
                            url: e.clinicUser.clinic.image.thumb.url,
                        },
                        width: e.clinicUser.clinic.image.width || 0,
                        height: e.clinicUser.clinic.image.height || 0,
                        url: e.clinicUser.clinic.image.url,
                    },
                    phone: e.clinicUser.clinic.phone,
                    showInSite: !!e.clinicUser.clinic.showInSite,
                    address: {
                        zipcode: e.clinicUser.clinic.address.zipcode,
                        street: e.clinicUser.clinic.address.street,
                        streetNumber: e.clinicUser.clinic.address.streetNumber,
                        complementary: e.clinicUser.clinic.address.complementary,
                        neighborhood: e.clinicUser.clinic.address.neighborhood,
                        city: e.clinicUser.clinic.address.city,
                        state: e.clinicUser.clinic.address.state,
                    },
                    code: e.clinicUser.clinic.code || 0,
                    codeFormat: e.clinicUser.clinic.codeFormat,
                    services: e.clinicUser.clinic.services === null || e.clinicUser.clinic.services === undefined ? null : e.clinicUser.clinic.services,
                    createdAt: new Date(e.clinicUser.clinic.createdAt + "Z"),
                    adminUser: e.clinicUser.clinic.adminUser === null || e.clinicUser.clinic.adminUser === undefined ? null : {
                        name: e.clinicUser.clinic.adminUser.name,
                        documentNumber: e.clinicUser.clinic.adminUser.documentNumber,
                    },
                },
                createdAt: new Date(e.clinicUser.createdAt + "Z"),
                name: e.clinicUser.name,
                email: e.clinicUser.email,
                documentNumber: e.clinicUser.documentNumber,
            },
            createdAt: new Date(e.createdAt + "Z"),
        })),
    };
}
exports.getHomeData = getHomeData;
async function getAllMyPets(pageOffset, options) {
    const args = {
        pageOffset: pageOffset || 0,
    };
    const ret = await makeRequest({ name: "getAllMyPets", args, options });
    return ret.map((e) => ({
        id: e.id,
        name: e.name,
        image: {
            thumb: {
                width: e.image.thumb.width || 0,
                height: e.image.thumb.height || 0,
                url: e.image.thumb.url,
            },
            width: e.image.width || 0,
            height: e.image.height || 0,
            url: e.image.url,
        },
        age: e.age,
        species: e.species,
        animalSex: e.animalSex,
        isCastrated: !!e.isCastrated,
        code: e.code || 0,
        breed: e.breed,
        birthdate: new Date(e.birthdate + "Z"),
        codeFormat: e.codeFormat,
    }));
}
exports.getAllMyPets = getAllMyPets;
async function getMyPetById(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "getMyPetById", args, options });
    return {
        id: ret.id,
        name: ret.name,
        image: {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        age: ret.age,
        species: ret.species,
        animalSex: ret.animalSex,
        isCastrated: !!ret.isCastrated,
        code: ret.code || 0,
        breed: ret.breed,
        birthdate: new Date(ret.birthdate + "Z"),
        codeFormat: ret.codeFormat,
    };
}
exports.getMyPetById = getMyPetById;
async function createMyPet(newPet, options) {
    const args = {
        newPet: {
            name: newPet.name,
            image: {
                bytes: newPet.image.bytes === null || newPet.image.bytes === undefined ? null : newPet.image.bytes.toString("base64"),
                image: newPet.image.image === null || newPet.image.image === undefined ? null : {
                    thumb: {
                        width: newPet.image.image.thumb.width || 0,
                        height: newPet.image.image.thumb.height || 0,
                        url: newPet.image.image.thumb.url,
                    },
                    width: newPet.image.image.width || 0,
                    height: newPet.image.image.height || 0,
                    url: newPet.image.image.url,
                },
            },
            age: newPet.age,
            species: newPet.species,
            animalSex: newPet.animalSex,
            isCastrated: !!newPet.isCastrated,
            breed: newPet.breed,
            birthdate: (typeof newPet.birthdate === "string" && newPet.birthdate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? newPet.birthdate.replace("Z", "") : newPet.birthdate.toISOString().replace("Z", "")),
        },
    };
    const ret = await makeRequest({ name: "createMyPet", args, options });
    return {
        id: ret.id,
        name: ret.name,
        image: {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        age: ret.age,
        species: ret.species,
        animalSex: ret.animalSex,
        isCastrated: !!ret.isCastrated,
        code: ret.code || 0,
        breed: ret.breed,
        birthdate: new Date(ret.birthdate + "Z"),
        codeFormat: ret.codeFormat,
    };
}
exports.createMyPet = createMyPet;
async function editMyPet(id, editPet, options) {
    const args = {
        id: id,
        editPet: {
            name: editPet.name,
            image: {
                bytes: editPet.image.bytes === null || editPet.image.bytes === undefined ? null : editPet.image.bytes.toString("base64"),
                image: editPet.image.image === null || editPet.image.image === undefined ? null : {
                    thumb: {
                        width: editPet.image.image.thumb.width || 0,
                        height: editPet.image.image.thumb.height || 0,
                        url: editPet.image.image.thumb.url,
                    },
                    width: editPet.image.image.width || 0,
                    height: editPet.image.image.height || 0,
                    url: editPet.image.image.url,
                },
            },
            age: editPet.age,
            species: editPet.species,
            animalSex: editPet.animalSex,
            isCastrated: !!editPet.isCastrated,
            breed: editPet.breed,
            birthdate: (typeof editPet.birthdate === "string" && editPet.birthdate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? editPet.birthdate.replace("Z", "") : editPet.birthdate.toISOString().replace("Z", "")),
        },
    };
    const ret = await makeRequest({ name: "editMyPet", args, options });
    return {
        id: ret.id,
        name: ret.name,
        image: {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        age: ret.age,
        species: ret.species,
        animalSex: ret.animalSex,
        isCastrated: !!ret.isCastrated,
        code: ret.code || 0,
        breed: ret.breed,
        birthdate: new Date(ret.birthdate + "Z"),
        codeFormat: ret.codeFormat,
    };
}
exports.editMyPet = editMyPet;
async function countMyPets(options) {
    const ret = await makeRequest({ name: "countMyPets", args: {}, options });
    return ret || 0;
}
exports.countMyPets = countMyPets;
async function sendRequestResetPassword(email, options) {
    const args = {
        email: email,
    };
    await makeRequest({ name: "sendRequestResetPassword", args, options });
    return undefined;
}
exports.sendRequestResetPassword = sendRequestResetPassword;
async function validateToken(token, options) {
    const args = {
        token: token,
    };
    const ret = await makeRequest({ name: "validateToken", args, options });
    return !!ret;
}
exports.validateToken = validateToken;
async function resetPassword(token, newPassword, options) {
    const args = {
        token: token,
        newPassword: newPassword,
    };
    await makeRequest({ name: "resetPassword", args, options });
    return undefined;
}
exports.resetPassword = resetPassword;
async function getCurrentUser(options) {
    const ret = await makeRequest({ name: "getCurrentUser", args: {}, options });
    return {
        id: ret.id,
        email: ret.email,
        name: ret.name,
        password: ret.password,
        documentNumber: ret.documentNumber,
        phone: ret.phone,
        image: ret.image === null || ret.image === undefined ? null : {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        petParents: ret.petParents,
    };
}
exports.getCurrentUser = getCurrentUser;
async function userLogin(email, password, options) {
    const args = {
        email: email,
        password: password,
    };
    const ret = await makeRequest({ name: "userLogin", args, options });
    return {
        id: ret.id,
        email: ret.email,
        name: ret.name,
        password: ret.password,
        documentNumber: ret.documentNumber,
        phone: ret.phone,
        image: ret.image === null || ret.image === undefined ? null : {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        petParents: ret.petParents,
    };
}
exports.userLogin = userLogin;
async function editCurrentUser(editUser, options) {
    const args = {
        editUser: {
            email: editUser.email,
            name: editUser.name,
            phone: editUser.phone,
            documentNumber: editUser.documentNumber,
            petParents: editUser.petParents,
            image: editUser.image === null || editUser.image === undefined ? null : {
                bytes: editUser.image.bytes === null || editUser.image.bytes === undefined ? null : editUser.image.bytes.toString("base64"),
                image: editUser.image.image === null || editUser.image.image === undefined ? null : {
                    thumb: {
                        width: editUser.image.image.thumb.width || 0,
                        height: editUser.image.image.thumb.height || 0,
                        url: editUser.image.image.thumb.url,
                    },
                    width: editUser.image.image.width || 0,
                    height: editUser.image.image.height || 0,
                    url: editUser.image.image.url,
                },
            },
        },
    };
    const ret = await makeRequest({ name: "editCurrentUser", args, options });
    return {
        id: ret.id,
        email: ret.email,
        name: ret.name,
        password: ret.password,
        documentNumber: ret.documentNumber,
        phone: ret.phone,
        image: ret.image === null || ret.image === undefined ? null : {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        petParents: ret.petParents,
    };
}
exports.editCurrentUser = editCurrentUser;
async function updateCurrentUserPassword(currentPassword, newPassword, options) {
    const args = {
        currentPassword: currentPassword,
        newPassword: newPassword,
    };
    const ret = await makeRequest({ name: "updateCurrentUserPassword", args, options });
    return {
        id: ret.id,
        email: ret.email,
        name: ret.name,
        password: ret.password,
        documentNumber: ret.documentNumber,
        phone: ret.phone,
        image: ret.image === null || ret.image === undefined ? null : {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        petParents: ret.petParents,
    };
}
exports.updateCurrentUserPassword = updateCurrentUserPassword;
async function logoutUser(options) {
    await makeRequest({ name: "logoutUser", args: {}, options });
    return undefined;
}
exports.logoutUser = logoutUser;
async function getUser(id, options) {
    const args = {
        id: id,
    };
    const ret = await makeRequest({ name: "getUser", args, options });
    return {
        id: ret.id,
        email: ret.email,
        name: ret.name,
        password: ret.password,
        documentNumber: ret.documentNumber,
        phone: ret.phone,
        image: ret.image === null || ret.image === undefined ? null : {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        petParents: ret.petParents,
    };
}
exports.getUser = getUser;
async function deleteMyAccount(password, options) {
    const args = {
        password: password,
    };
    const ret = await makeRequest({ name: "deleteMyAccount", args, options });
    return {
        id: ret.id,
        email: ret.email,
        name: ret.name,
        password: ret.password,
        documentNumber: ret.documentNumber,
        phone: ret.phone,
        image: ret.image === null || ret.image === undefined ? null : {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        petParents: ret.petParents,
    };
}
exports.deleteMyAccount = deleteMyAccount;
async function createUserWithPet(newUserWithPet, options) {
    const args = {
        newUserWithPet: {
            newPet: newUserWithPet.newPet === null || newUserWithPet.newPet === undefined ? null : {
                name: newUserWithPet.newPet.name,
                image: {
                    bytes: newUserWithPet.newPet.image.bytes === null || newUserWithPet.newPet.image.bytes === undefined ? null : newUserWithPet.newPet.image.bytes.toString("base64"),
                    image: newUserWithPet.newPet.image.image === null || newUserWithPet.newPet.image.image === undefined ? null : {
                        thumb: {
                            width: newUserWithPet.newPet.image.image.thumb.width || 0,
                            height: newUserWithPet.newPet.image.image.thumb.height || 0,
                            url: newUserWithPet.newPet.image.image.thumb.url,
                        },
                        width: newUserWithPet.newPet.image.image.width || 0,
                        height: newUserWithPet.newPet.image.image.height || 0,
                        url: newUserWithPet.newPet.image.image.url,
                    },
                },
                age: newUserWithPet.newPet.age,
                species: newUserWithPet.newPet.species,
                animalSex: newUserWithPet.newPet.animalSex,
                isCastrated: !!newUserWithPet.newPet.isCastrated,
                breed: newUserWithPet.newPet.breed,
                birthdate: (typeof newUserWithPet.newPet.birthdate === "string" && newUserWithPet.newPet.birthdate.match(/^[0-9]{4}-[01][0-9]-[0123][0-9]T[012][0-9]:[0123456][0-9]:[0123456][0-9](\.[0-9]{1,6})?Z?$/) ? newUserWithPet.newPet.birthdate.replace("Z", "") : newUserWithPet.newPet.birthdate.toISOString().replace("Z", "")),
            },
            password: newUserWithPet.password,
            email: newUserWithPet.email,
            name: newUserWithPet.name,
            phone: newUserWithPet.phone,
            documentNumber: newUserWithPet.documentNumber,
            petParents: newUserWithPet.petParents,
            image: newUserWithPet.image === null || newUserWithPet.image === undefined ? null : {
                bytes: newUserWithPet.image.bytes === null || newUserWithPet.image.bytes === undefined ? null : newUserWithPet.image.bytes.toString("base64"),
                image: newUserWithPet.image.image === null || newUserWithPet.image.image === undefined ? null : {
                    thumb: {
                        width: newUserWithPet.image.image.thumb.width || 0,
                        height: newUserWithPet.image.image.thumb.height || 0,
                        url: newUserWithPet.image.image.thumb.url,
                    },
                    width: newUserWithPet.image.image.width || 0,
                    height: newUserWithPet.image.image.height || 0,
                    url: newUserWithPet.image.image.url,
                },
            },
        },
    };
    const ret = await makeRequest({ name: "createUserWithPet", args, options });
    return {
        id: ret.id,
        email: ret.email,
        name: ret.name,
        password: ret.password,
        documentNumber: ret.documentNumber,
        phone: ret.phone,
        image: ret.image === null || ret.image === undefined ? null : {
            thumb: {
                width: ret.image.thumb.width || 0,
                height: ret.image.thumb.height || 0,
                url: ret.image.thumb.url,
            },
            width: ret.image.width || 0,
            height: ret.image.height || 0,
            url: ret.image.url,
        },
        petParents: ret.petParents,
    };
}
exports.createUserWithPet = createUserWithPet;
async function createUserDeleteRequest(password, options) {
    const args = {
        password: password,
    };
    const ret = await makeRequest({ name: "createUserDeleteRequest", args, options });
    return {
        id: ret.id,
        user: {
            id: ret.user.id,
            email: ret.user.email,
            name: ret.user.name,
            password: ret.user.password,
            documentNumber: ret.user.documentNumber,
            phone: ret.user.phone,
            image: ret.user.image === null || ret.user.image === undefined ? null : {
                thumb: {
                    width: ret.user.image.thumb.width || 0,
                    height: ret.user.image.thumb.height || 0,
                    url: ret.user.image.thumb.url,
                },
                width: ret.user.image.width || 0,
                height: ret.user.image.height || 0,
                url: ret.user.image.url,
            },
            petParents: ret.user.petParents,
        },
        acceptedAt: ret.acceptedAt === null || ret.acceptedAt === undefined ? null : new Date(ret.acceptedAt + "Z"),
        createdAt: new Date(ret.createdAt + "Z"),
    };
}
exports.createUserDeleteRequest = createUserDeleteRequest;
async function ping(options) {
    const ret = await makeRequest({ name: "ping", args: {}, options });
    return ret;
}
exports.ping = ping;
async function setPushToken(token, options) {
    const args = {
        token: token,
    };
    await makeRequest({ name: "setPushToken", args, options });
    return undefined;
}
exports.setPushToken = setPushToken;
//////////////////////////////////////////////////////
let fallbackDeviceId = null;
function setDeviceId(deviceId, ctx) {
    if (!exports.isServer) {
        fallbackDeviceId = deviceId;
        try {
            Cookies.set("deviceId", deviceId);
            localStorage.setItem("deviceId", deviceId);
        }
        catch (e) { }
    }
    else {
        if (ctx) {
            ctx.deviceId = deviceId;
        }
    }
}
function getDeviceId(ctx) {
    if (!exports.isServer) {
        try {
            return localStorage.getItem("deviceId") || fallbackDeviceId;
        }
        catch (e) { }
        return fallbackDeviceId;
    }
    else {
        return ctx ? (ctx.deviceId ? ctx.deviceId : null) : null;
    }
}
exports.getDeviceId = getDeviceId;
function device(ctx) {
    let platform = null;
    if (!exports.isServer) {
        const parser = new ua_parser_js_1.UAParser();
        parser.setUA(navigator.userAgent);
        const agent = parser.getResult();
        platform = {
            browser: agent.browser.name,
            browserVersion: agent.browser.version,
            os: agent.os.name,
            osVersion: agent.os.version
        };
    }
    const device = {
        id: getDeviceId(ctx),
        type: !exports.isServer ? "web" : "ssr",
        platform: platform,
        screen: !exports.isServer ? {
            width: screen.width,
            height: screen.height
        } : null,
        version: !exports.isServer && document.currentScript ?
            document.currentScript.src :
            "",
        language: (ctx ? exports.parseCookies(ctx.req).acceptLanguage : !exports.isServer ? navigator.language : "pt-BR") || "pt-BR",
    };
    return device;
}
function randomBytesHex(len) {
    let hex = "";
    for (let i = 0; i < 2 * len; ++i)
        hex += "0123456789abcdef"[Math.floor(Math.random() * 16)];
    return hex;
}
const listenersDict = {
    fail: [],
    fatal: [],
    success: [],
};
function addEventListener(listenable, hook) {
    const listeners = listenersDict[listenable];
    listeners.push(hook);
}
exports.addEventListener = addEventListener;
function removeEventListener(listenable, hook) {
    const listeners = listenersDict[listenable];
    listenersDict[listenable] = listeners.filter(h => h !== hook);
}
exports.removeEventListener = removeEventListener;
async function makeRequest({ name, args, options }) {
    const deviceData = device(options ? options.ctx : undefined);
    if (options && options.device) {
        const device = options.device;
        if (device.id) {
            deviceData.id = device.id;
        }
        if (device.type) {
            deviceData.type = device.type;
        }
        if (device.platform) {
            deviceData.platform = device.platform;
        }
        if (device.screen) {
            deviceData.screen = device.screen;
        }
        if (device.version) {
            deviceData.version = device.version;
        }
        if (device.language) {
            deviceData.language = device.language;
        }
    }
    if (!exports.isServer) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            const requestUrl = `${baseUrl.startsWith("http") || baseUrl.startsWith("localhost") ?
                "" :
                "https://"}${baseUrl}/${name}`;
            req.open("POST", requestUrl);
            const body = {
                id: randomBytesHex(8),
                device: deviceData,
                name: name,
                args: args,
            };
            req.onreadystatechange = () => {
                if (req.readyState !== 4)
                    return;
                try {
                    const response = JSON.parse(req.responseText);
                    try {
                        setDeviceId(response.deviceId);
                        if (response.ok) {
                            resolve(response.result);
                            listenersDict["success"].forEach((hook) => hook(response.result, name, args));
                        }
                        else {
                            const error = typeof response.error === "object" ?
                                response.error :
                                { type: "Fatal", message: response.toString() };
                            reject(error);
                            listenersDict["fail"].forEach((hook) => hook(error, name, args));
                        }
                    }
                    catch (e) {
                        console.error(e);
                        reject({ type: "Fatal", message: `[${name}] ${e.toString()}` });
                        listenersDict["fatal"].forEach((hook) => hook(e, name, args));
                    }
                }
                catch (e) {
                    console.error(e);
                    reject({ type: "BadFormattedResponse", message: `Response couldn't be parsed as JSON (${req.responseText}):\n${e.toString()}` });
                    listenersDict["fatal"].forEach((hook) => hook(e, name, args));
                }
            };
            req.send(JSON.stringify(body));
        });
    }
    return new Promise((resolve, reject) => {
        const requestUrl = `${baseUrl.startsWith("http") || baseUrl.startsWith("localhost") ?
            "" :
            "https://"}${baseUrl}/${name}`;
        const body = {
            id: randomBytesHex(8),
            device: deviceData,
            name: name,
            args: args
        };
        axios_1.default.post(requestUrl, body, {
            onUploadProgress: (p) => {
                if (p.loaded && p.total && options && options.progress) {
                    options.progress(Math.ceil(((p.loaded / p.total) * 100)));
                }
            },
            validateStatus: () => true,
        }).then((res) => {
            const response = res.data;
            try {
                setDeviceId(response.deviceId, options ? options.ctx : undefined);
                if (response.ok) {
                    resolve(response.result);
                    if (!exports.isServer) {
                        listenersDict["success"].forEach(hook => hook(response.result, name, args));
                    }
                }
                else {
                    const error = typeof response.error === "object" ?
                        response.error :
                        { type: "Fatal", message: response.toString() };
                    reject(error);
                    if (!exports.isServer) {
                        listenersDict["fail"].forEach((hook) => hook(error, name, args));
                    }
                }
            }
            catch (e) {
                console.error(e);
                reject({ type: "Fatal", message: `[${name}] ${e.toString()}` });
                if (!exports.isServer) {
                    listenersDict["fatal"].forEach((hook) => hook(e, name, args));
                }
            }
        }).catch((e) => {
            console.error(e);
            reject({
                type: "BadFormattedResponse",
                message: `Response couldn't be parsed as JSON:\n${typeof e === "object" ? JSON.stringify(e) : e.toString()}`
            });
            if (!exports.isServer) {
                listenersDict["fatal"].forEach((hook) => hook(e, name, args));
            }
        });
    });
}
//# sourceMappingURL=api.js.map